import { Locales } from '../enum/locales';
import { TLocales } from '../type/locales';
import { OptimizedImage } from './optimized-image';
import { IReciter } from '../interfaces/i-reciter';

export class Reciter {
  id: number;
  guid: string;
  slug: string;
  titleEn: string;
  titleAr: string;
  descriptionPreview: string;
  biblioEn: string;
  biblioFr: string;
  biblioAr: string;
  biblioHTMLEn: string;
  biblioHTMLFr: string;
  biblioHTMLAr: string;
  label: string;
  number: number;
  plist: string;
  timingVersion: number;
  isHidden: boolean;
  isFeatured: boolean;
  isPremium: boolean;
  isPublished: boolean;
  isIncomplete: boolean;
  isTiming: boolean;
  isPartial: boolean;
  featuredTitleColor: string;
  featuredOrder: number;
  order: number;
  facebook: string;
  twitter: string;
  instagram: string;
  youtube: string;
  snapchat: string;
  link: string;
  imageText: string;
  timingLink: string;
  metaTitle: string;
  metaDescription: string;
  image: OptimizedImage | null;
  transparentImage: OptimizedImage | null;
  featureCover: OptimizedImage | null;
  featureWideCover: OptimizedImage | null;

  constructor(data: IReciter, locale: TLocales | string = Locales.en) {
    this.id = data.id;
    this.guid = data.guid;
    this.slug = data.slug;
    this.titleEn = data.title_en;
    this.titleAr = data.title_ar;
    this.descriptionPreview = data.description_preview;
    this.biblioEn = data.biblio_en;
    this.biblioFr = data.biblio_fr;
    this.biblioAr = data.biblio_ar;
    this.biblioHTMLEn = data.biblio_html_en;
    this.biblioHTMLFr = data.biblio_html_fr;
    this.biblioHTMLAr = data.biblio_html_ar;
    this.label = data.label;
    this.number = data.number;
    this.plist = data.plist;
    this.timingVersion = data.timing_version;
    this.isHidden = data.is_hidden;
    this.isFeatured = data.is_featured;
    this.isPremium = data.is_premium;
    this.isPublished = data.is_published;
    this.isIncomplete = data.is_incomplete;
    this.isTiming = data.is_timing;
    this.isPartial = data.is_partial;
    this.featuredTitleColor = data.featured_title_color;
    this.featuredOrder = data.featured_order;
    this.order = data.order;
    this.facebook = data.facebook;
    this.twitter = data.twitter;
    this.instagram = data.instagram;
    this.youtube = data.youtube;
    this.snapchat = data.snapchat;
    this.link = data.link;
    this.imageText = data.image_text;
    this.timingLink = data.timing_link;
    this.metaTitle = data.meta_title;
    this.metaDescription = data.meta_description;
    this.image = data.image ? new OptimizedImage(data.image) : null;
    this.transparentImage = data.transparent_image
      ? new OptimizedImage(data.transparent_image)
      : null;
    this.featureCover = data.feature_cover
      ? new OptimizedImage(data.feature_cover)
      : null;
    this.featureWideCover = data.feature_wide_cover
      ? new OptimizedImage(data.feature_wide_cover)
      : null;
  }
}
